// removed by extract-text-webpack-plugin
module.exports = {"clickarea":"Summary-hashed__clickarea__3kcJY","clickarea__content":"Summary-hashed__clickarea__content__2zkNW","clickarea__header":"Summary-hashed__clickarea__header__13PqO","clickarea__chevron":"Summary-hashed__clickarea__chevron__1NrM3","memo":"Summary-hashed__memo__2_te_"};


//////////////////
// WEBPACK FOOTER
// ./app/customer/js/src/edge/policycommon/common/directives/schedules/MobileViewGenerator/Summary-hashed.scss
// module id = 665
// module chunks = 0